import { gql } from '__generated__';

export default gql(`
  mutation ActivateEvent($id: ID!) {
    activateEvent(id: $id) {
      id
      active
    }
  }
`);
